/* eslint-disable @typescript-eslint/naming-convention */
export class ConfigHeader {
	public active_business_unit: string;
	public active_logging_style: string;
	public active_sstn_logging_style: string;
	public userID: string;
	public first_name: string;
	public export_date: string;
	public fusion_version: string;
	public device_id: string;
	public registration_token: string;
}
